var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditQuantity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16667 5.45833H1.775C1.43685 5.45833 1.11255 5.59266 0.873439 5.83177C0.63433 6.07088 0.5 6.39518 0.5 6.73333V9.85C0.5 10.1882 0.63433 10.5125 0.873439 10.7516C1.11255 10.9907 1.43685 11.125 1.775 11.125H6.16667M6.16667 5.45833V11.125M6.16667 5.45833H10.5583C10.8965 5.45833 11.2208 5.59266 11.4599 5.83177C11.699 6.07088 11.8333 6.39518 11.8333 6.73333V9.85C11.8333 10.1882 11.699 10.5125 11.4599 10.7516C11.2208 10.9907 10.8965 11.125 10.5583 11.125H6.16667M1.91667 1.775C1.91667 1.43685 2.051 1.11255 2.29011 0.873439C2.52921 0.63433 2.85352 0.5 3.19167 0.5H7.725C8.06315 0.5 8.38745 0.63433 8.62656 0.873439C8.86567 1.11255 9 1.43685 9 1.775V5.45833H3.19167C3.02423 5.45833 2.85844 5.42535 2.70375 5.36128C2.54906 5.2972 2.4085 5.20329 2.29011 5.08489C2.17171 4.9665 2.0778 4.82594 2.01372 4.67125C1.94965 4.51656 1.91667 4.35077 1.91667 4.18333V1.775Z",
    stroke: "#262F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00016 5.45833V7.58333M3.3335 5.45833V7.58333M5.4585 0.5V2.625",
    stroke: "#262F5F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditQuantity);
export default __webpack_public_path__ + "static/media/edit-quantity.c8d7b7dbc07a461b422ac9d552f3d0eb.svg";
export { ForwardRef as ReactComponent };